import { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import './CountDownTimer.scss';

import * as S from '../store/selectors';
import {
  startOfPresaleTimestamp,
} from '../configs';

const labels = {
  days: 'DAY',
  hours: 'HRS',
  minutes: 'MIN',
  seconds: 'SEC',
};


const twoDigits = (value) => {
  if (value.toString().length <= 1) {
    return '0' + value.toString();
  }
  return value.toString();
}


const dataState = () => {
  const uuid = uuidv4();
  return {
    now: Math.trunc(new Date().getTime() / 1000),
    date: null,
    //interval: null,
    diff: 0,
    show: false,
    timeData: [{
      current: 0,
      previous: 0,
      label: labels.days,
      elementId: 'flip-card-days-' + uuid,
    },
    {
      current: 0,
      previous: 0,
      label: labels.hours,
      elementId: 'flip-card-hours-' + uuid,
    },
    {
      current: 0,
      previous: 0,
      label: labels.minutes,
      elementId: 'flip-card-minutes-' + uuid,
    },
    {
      current: 0,
      previous: 0,
      label: labels.seconds,
      elementId: 'flip-card-seconds-' + uuid,
    }],
  };
};


function CountDownTimer() {
  const timestamp = useSelector(S.nft.getTimestamp);
  const timestampPresale = useSelector(S.nft.getTimestampPresale);
  const timestampPresaleEnd = useSelector(S.nft.getTimestampPresaleEnd);
  const timestampSale = useSelector(S.nft.getTimestampSale);

  const [deadline, setDeadline] = useState(startOfPresaleTimestamp);
  useEffect(() => {
    if (timestamp < timestampPresaleEnd && deadline !== timestampPresale)
      setDeadline(timestampPresale);
    if (timestamp >= timestampPresaleEnd && deadline !== timestampSale)
      setDeadline(timestampSale);
  }, [timestamp, timestampPresale, timestampPresaleEnd, timestampSale]);


  const [state, setState] = useState(dataState);

  const seconds = () => {
    return Math.trunc(state.diff) % 60;
  }
  const minutes = () => {
    return Math.trunc(state.diff / 60) % 60;
  }
  const hours = () => {
    return Math.trunc(state.diff / 60 / 60) % 24;
  }
  const days = () => {
    return Math.trunc(state.diff / 60 / 60 / 24);
  }

  const updateTime = (idx, newValue) => {
    if (idx >= state.timeData.length || newValue === undefined) {
      return;
    }

    const d = state.timeData[idx];
    const val = newValue < 0 ? 0 : newValue;
    const el = document.querySelector(`#${d.elementId}`);
    if (val !== d.current) {
      d.previous = d.current;
      d.current = val;
      if (el) {
        el.classList.remove('flip');
        void el.offsetWidth;
        el.classList.add('flip');
      }
      if (idx === 0) {
        const els = el.querySelectorAll('span b');
        if (els) {
          for (let e of els) {
            const cls = e.classList[0];
            if (newValue / 1000 >= 1) {
              if (!cls.includes('-4digits')) {
                const newCls = cls + '-4digits';
                e.classList.add(newCls);
                e.classList.remove(cls);
              }
            } else {
              if (cls.includes('-4digits')) {
                const newCls = cls.replace('-4digits', '');
                e.classList.add(newCls);
                e.classList.remove(cls);
              }
            }
          }
        }
      }
    }
  }
  const updateAllCards = () => {
    updateTime(0, days());
    updateTime(1, hours());
    updateTime(2, minutes());
    updateTime(3, seconds());
  }


  useEffect(() => {
    const date = deadline;
    if (!date) {
      throw new Error("Invalid props value, correct the 'deadline'");
    }
    const now = Math.trunc(new Date().getTime() / 1000);
    const diff = date - now;
    setState({ ...state, date, now, diff });

    const intervalId = setInterval(() => {
      const date = deadline;
      const now = Math.trunc(new Date().getTime() / 1000);
      const diff = date - now;
      setState({ ...state, date, now, diff, });
    }, 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [deadline]);


  useEffect(() => {
    updateAllCards();
  }, [state.now]);

  return (
    <div className="flip-clock">
      {state.timeData.map((item, index) => {
        return (
          <span
            key={index}
            className="flip-clock__piece"
            id={item.elementId}
          >
            <span className="flip-clock__card flip-card"
            //style="countdownSize ? `font-size:${countdownSize}` : ''"
            >
              <b className="flip-card__top" >{twoDigits(item.current)}</b>
              {/*<b className="flip-card__bottom">{twoDigits(item.current)}</b>
                <b className="flip-card__back">{twoDigits(item.previous)}</b>
                <b className="flip-card__back-bottom">{twoDigits(item.previous)}</b>*/}
            </span>
            <span className="flip-clock__slot"
            //:style="labelSize ? `font-size:${labelSize}` : ''"
            >{item.label}</span>
          </span>
        );
      })}
    </div>
  );
};

export default hot(module)(CountDownTimer);
